var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerfectsvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "123.625px",
    height: "123.607px",
    viewBox: "16 15.563 123.625 123.607",
    enableBackground: "new 16 15.563 123.625 123.607",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#C28562",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 59.158,138.668 59.158,16.395 138.902,16.395 138.902,138.668  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#C28562",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 16.629,138.668 16.629,48.291 59.158,48.291 59.158,138.668  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.578,
    y: 64.24,
    fill: "none",
    stroke: "#C28562",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    width: 26.581,
    height: 15.947
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.578,
    y: 96.139,
    fill: "none",
    stroke: "#C28562",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    width: 26.581,
    height: 15.949
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C28562",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M112.32,138.668 H85.74v-15.947c0-5.873,4.761-10.633,10.632-10.633h5.317c5.871,0,10.631,4.76,10.631,10.633V138.668z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#C28562",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 75.107,
    y1: 32.342,
    x2: 80.424,
    y2: 32.342
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#C28562",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 96.372,
    y1: 32.342,
    x2: 101.689,
    y2: 32.342
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#C28562",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 117.637,
    y1: 32.342,
    x2: 122.953,
    y2: 32.342
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#C28562",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 75.107,
    y1: 48.291,
    x2: 80.424,
    y2: 48.291
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#C28562",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 96.372,
    y1: 48.291,
    x2: 101.689,
    y2: 48.291
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#C28562",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 117.637,
    y1: 48.291,
    x2: 122.953,
    y2: 48.291
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#C28562",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 75.107,
    y1: 64.24,
    x2: 80.424,
    y2: 64.24
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#C28562",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 96.372,
    y1: 64.24,
    x2: 101.689,
    y2: 64.24
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#C28562",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 117.637,
    y1: 64.24,
    x2: 122.953,
    y2: 64.24
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#C28562",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 75.107,
    y1: 80.188,
    x2: 80.424,
    y2: 80.188
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#C28562",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 96.372,
    y1: 80.188,
    x2: 101.689,
    y2: 80.188
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#C28562",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 117.637,
    y1: 80.188,
    x2: 122.953,
    y2: 80.188
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#C28562",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 75.107,
    y1: 96.139,
    x2: 80.424,
    y2: 96.139
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#C28562",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 96.372,
    y1: 96.139,
    x2: 101.689,
    y2: 96.139
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#C28562",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 117.637,
    y1: 96.139,
    x2: 122.953,
    y2: 96.139
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfectsvg);
export default __webpack_public_path__ + "static/media/perfectsvg.f46f0eb4db42c5837c4aacd4b0b8c0a4.svg";
export { ForwardRef as ReactComponent };